let staff_tickets = function( $ ) {

	let $wrapper;

	let _init = function() {
		$wrapper = $( '#staff-tickets-page' );

		if ( $wrapper.length > 0 ) {
			_init_filter_form();
		}
	};

	let _init_filter_form = function() {
		let $form   = $wrapper.find( '#tickets-filter' ),
			$select = $form.find( 'select' );

		$select.select2({
			dropdownParent: $select.closest( '.field-wrap' ),
			placeholder: 'Filter by staff member',
		});

		$select.on( 'change', ( e ) => {
			$form.submit();
		} );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = staff_tickets;